import React, { useEffect, useState } from 'react';
import SideMenu from '../sideMenu';
import DashboardHeader from '../topbar';
import Styles from "./styles.module.scss";
import Button from "../../components/button";
// import Resources from "../submitResources";
import Resources from '../submitResources/resource';
import priceIcon from "../../assets/images/resources-price.svg";
import workTypeIcon from "../../assets/images/work-type.svg";
import levelIcon from "../../assets/images/level_icon.svg";
import locationIcon from "../../assets/images/loc-icon.svg";
import calendarIcon from "../../assets/images/calendar_icon.svg";
import billingIcon from "../../assets/images/billing_icon.svg";
import crownIcon from "../../assets/images/crown_icon.svg";
import Table from "../../components/selectTable";
import {
  Grid,
  GridCellProps,
  GridColumn as Column,
  GridItemChangeEvent,
  GridPageChangeEvent,
  GridPagerSettings,
  GridRowProps,
} from "@progress/kendo-react-grid";
import { Error } from "@progress/kendo-react-labels";
import SearchBar from "../../components/searchbar";
import { Navigate, useNavigate } from 'react-router-dom';
import { checkPriority, convertMilliSecToDateNew, priorityClass } from '../../utils/EllowUtils';
import { useLocation } from 'react-router-dom';
import PositionFilter from '../../modal/positionFilter';
import SubmitResources from '../submitResources';

interface AppState {
  items: any;
  total: number;
  skip: number;
  pageSize: number;
  pageable: GridPagerSettings;
}




function ResourceApplyPosition(props: any) {

  const location = useLocation()
  // const data: any = location.state ? location.state : null
  const data: any = JSON.parse(localStorage.getItem("resourceApplyPositions") || "") || location.state.dataItem || null

  const [error, setError] = useState<string>()
  const [count, setCount] = useState<number>(0)
  const [jobId, setJobId] = useState<string>('')
  const [filter, setFilter] = useState<boolean>(false)
  const [dataItem, setDataItem] = useState<any>(data)
  const [availability, SetAvailability] = useState<string>()
  const [jobMetadata, setJobMetadata] = useState<{
    resourceCount: number, priority: number, experienceRange: { min: number, max: number }, contractDuration: string, contractStartDate: number, minimumBudget: any, maximumBudget: any,
    billingType: string, jobRole: { id: number, name: string }, coreSkills: [{ skillId: number, skillName: string }], otherSkills: [{ skillId: number, skillName: string }]
  }>({
    resourceCount: 0, priority: 5, experienceRange: { min: 0, max: 12 }, contractDuration: "", contractStartDate: 0, minimumBudget: 0, maximumBudget: 0,
    billingType: "", jobRole: { id: 0, name: "" }, coreSkills: [{ skillId: 0, skillName: "" }], otherSkills: [{ skillId: 0, skillName: "" }]
  })
  const [selectedCandidates, setSelectedCandidates] = useState([])
  const [submitResources, setSubmitResources] = useState<boolean>(false)
  const [defaultValues, setDefaultValues] = useState<any>()
  let navigate = useNavigate()

  const createState = (skip: number, take: number, items: any) => {
    let pagerSettings: GridPagerSettings = {
      buttonCount: 20,
      info: true,
      type: "numeric",
      pageSizes: [25, 50, 100],
      previousNext: true,
    };
    return {
      items: items,
      total: props.total && props.total,
      skip: skip,
      pageSize: take,
      pageable: pagerSettings,
    };
  };

  const [state, setState] = useState<AppState>(createState(0, 25, props.data));

  useEffect(() => {

    setState(createState(state.skip, state.pageSize, props.data));
    // setJobMetadata(props.jobMetadata)  
    if (dataItem.availability === 1) {
      SetAvailability('Immediately')
    } else if (dataItem.availability === 2) {
      SetAvailability('I’m getting relieved from my current job on a coming date')
    } else if (dataItem.availability === 3) {
      SetAvailability('In coming weeks after I get the offer')
    } else if (dataItem.availability === 4) {
      SetAvailability('Unavailable for jobs')
    } else {
      SetAvailability('In Contract')
    }
  }, [props.total, props.data, props.jobMetadata])


  const pageChange = (event: GridPageChangeEvent) => {
    setState(createState(event.page.skip, event.page.take, props.data));
    props.pageSize(event.page.take, event.page.skip)
  }

  const pageSize = (pageSize: any, pageNumber: number) => {
    props.pageSize(pageSize, pageNumber)
  }


  const onSubmit = (data: any) => {
    if (data) {
      props.onSubmit(data)
    }

  }

  const onSelection = (data: any) => {
    setSelectedCandidates(data)
    setJobId(data && data[0].jobId)
    setCount(data.length)
    setError('')

  }

  const submitResource = () => {
    if (selectedCandidates && selectedCandidates.length > 0) {
      if (selectedCandidates && selectedCandidates.length > 1) {
        setError('Select only one position')
      } else {
        setSubmitResources(true)
      }
    } else {
      setError('Select atleast one resource')
    }
  }

  const onRowClick = (data: any) => {
    setSelectedCandidates(data)
  }

  return (
    <>
      <div className="table-content-wrapper">
        <h3 className="headWithLabel">
          Job Description<label className={jobMetadata && priorityClass(jobMetadata.priority)}>{jobMetadata && checkPriority(jobMetadata.priority)}</label>
        </h3>
        <div className={Styles.jobStatusWrap}>
          <div className={Styles.jobStatus}>
            <figure>
              <img src={crownIcon} />
            </figure>
            <figcaption>Skills</figcaption>
            {dataItem && dataItem.skills && dataItem.skills.length !== 0 ? dataItem.skills.map((item: any, key: number) => {
              return (
                <h2 key={key}>{item}</h2>
              )
            }) : <h2>Not Mentioned</h2>}
          </div>
          <div className={Styles.jobStatus}>
            <figure>
              <img src={levelIcon} />{" "}
            </figure>
            <figcaption>Experience</figcaption>
            {dataItem && dataItem.experience === null ? <h2>Not Mentioned</h2> : <h2>{dataItem && dataItem.experience} Years</h2>}
          </div>
          <div className={Styles.jobStatus}>
            <figure>
              <img src={workTypeIcon} />
            </figure>
            <figcaption>Type of work preferred</figcaption>
            <h2>Not Mentioned</h2>
          </div>
          <div className={Styles.jobStatus}>
            <figure>
              <img src={locationIcon} />
            </figure>
            <figcaption>Location Preference</figcaption>
            <h2>Not Mentioned</h2>
          </div>
          <div className={Styles.jobStatus}>
            <figure>
              <img src={calendarIcon} />
            </figure>
            <figcaption>Availability</figcaption>
            <h2>{availability}</h2>
          </div>
          <div className={Styles.jobStatus}>
            <figure>
              <img src={priceIcon} />
            </figure>
            <figcaption>Resource rate</figcaption>
            <h2>Not Mentioned</h2>
          </div>
        </div>
      </div>
      <section className={Styles.dashboardWrapper}>
        <div className="table-content-wrapper">
          <div className={Styles.resourceHead}>
            <div className="tableHead">
              <div className="tableTitle">
                <h2>Positions</h2>
                <p>{`${count} Positions Selected`}</p>
              </div>
              <Button onClick={submitResource} variant="primary" size="small">
                Apply for this Position
              </Button>
            </div>
            <div className={Styles.resourceSearch}>
              <SearchBar searchChange={props.searchChange} filtervalues={props.filterValues} onClick={() => setFilter((prev) => !prev)} tagClose={(data: any) => { props.closeTag(data); setDefaultValues(data) }} />
            </div>
          </div>
          <Error>{error}</Error>
          <Table data={props.tableData} type={'resources'} total={props.total} state={state} pageChange={pageChange} pageSize={pageSize} onSelection={onSelection} onRowClick={onRowClick} />
        </div>
      </section>
      {submitResources && <SubmitResources type='resources' defaultValues={dataItem} jobId={jobId} ClickHandler={onSubmit} onClose={() => setSubmitResources(false)} />}
      {filter && <PositionFilter onClose={() => setFilter(false)} ClickHandler={(data: any) => { props.clickHandler(data, 'positions'); setFilter(false) }} companyList={props.companyList} allocatedTo={props.allocatedTo} positionName={props.positionName} defaultValues={props.filterValues} jobRolesList={props.jobRolesList} />}
    </>
  );
}

export default ResourceApplyPosition
